import { style } from '@angular/animations';

export const slideOutUp = [
  style({ transform: 'translate3d(0, 0, 0)', offset: 0 }),
  style({ transform: 'translate3d(0, -100%, 0)', offset: 1 }),
];

export const slideInDown = [
  style({ transform: 'translate3d(0, -100%, 0)', offset: 0 }),
  style({ transform: 'translate3d(0, 0, 0)', offset: 1 }),
];
